module.exports = __webpack_public_path__ + "img/send.ec295298.svg";